import React from 'react';
import { motion } from 'framer-motion';

const ConsultingFlyer = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white p-8">
      <div className="max-w-5xl mx-auto">
        {/* Header Section */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-8 text-center"
        >
          <h1 className="text-5xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-600 mb-4 leading-relaxed py-2">
            Omnigeist Consulting
          </h1>
          <p className="text-2xl text-gray-300 font-light">
            AI & .NET Expertise
          </p>
          <p className="text-xl text-blue-400 mt-4 italic">
            "I help enterprises rapidly integrate AI features into their .NET solutions—so your team can innovate faster with fewer manual bottlenecks."
          </p>
        </motion.div>

        {/* Main Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Left Column */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            className="space-y-6"
          >
            {/* Who I Am */}
            <div className="backdrop-blur-lg bg-white/10 rounded-xl p-6">
              <h2 className="text-2xl font-semibold mb-4 text-blue-400">Who I Am</h2>
              <ul className="space-y-3">
                <li><span className="font-semibold">Name:</span> Brett Garnier, Principal at Omnigeist LLC</li>
                <li><span className="font-semibold">Experience:</span> 25+ years on the Microsoft .NET stack; Certified Sitecore & Sitefinity Developer; AI solution architect</li>
                <li><span className="font-semibold">Location:</span> Based in Miami, FL (remote-friendly, global clients)</li>
              </ul>
            </div>

            {/* What I Do */}
            <div className="backdrop-blur-lg bg-white/10 rounded-xl p-6">
              <h2 className="text-2xl font-semibold mb-4 text-blue-400">What I Do</h2>
              <div className="space-y-4">
                <div>
                  <h3 className="font-semibold text-purple-400">AI & .NET Integration</h3>
                  <ul className="list-disc ml-5 space-y-1">
                    <li>Add AI-driven "copilots" to existing .NET applications</li>
                    <li>Implement auto function calling, RAG, and semantic search</li>
                    <li>Use GPT-4, Azure Cognitive Services, Anthropic Claude for enterprise solutions</li>
                  </ul>
                </div>
                <div>
                  <h3 className="font-semibold text-purple-400">CMS & Content Automation</h3>
                  <ul className="list-disc ml-5 space-y-1">
                    <li>Modernize or extend Sitecore/Sitefinity with AI</li>
                    <li>Drive innovation in enterprise content management</li>
                  </ul>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Right Column */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            className="space-y-6"
          >
            {/* How I Work */}
            <div className="backdrop-blur-lg bg-white/10 rounded-xl p-6">
              <h2 className="text-2xl font-semibold mb-4 text-blue-400">How I Work</h2>
              <div className="space-y-4">
                <div>
                  <h3 className="font-semibold text-purple-400">Rapid 3-Month Pilot Projects</h3>
                  <ul className="list-disc ml-5 space-y-1">
                    <li>Phase 1: Strategy & Architecture (2 weeks)</li>
                    <li>Phase 2: Implementation & Testing (6–8 weeks)</li>
                    <li>Phase 3: Handoff & Team Training (2–4 weeks)</li>
                  </ul>
                </div>
                <div>
                  <h3 className="font-semibold text-purple-400">Flexible Engagement</h3>
                  <ul className="list-disc ml-5 space-y-1">
                    <li>Fractional AI leadership (ongoing advisory)</li>
                    <li>Long-term support as needed for enterprise clients</li>
                    <li>Near-shore .NET dev team augmentation</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Tech Stack */}
            <div className="backdrop-blur-lg bg-white/10 rounded-xl p-6">
              <h2 className="text-2xl font-semibold mb-4 text-blue-400">Tech Highlights</h2>
              <div className="space-y-2">
                <p><span className="font-semibold text-purple-400">Tech Stack:</span> .NET 8, Blazor, Azure/AWS, Docker, Python Interop, EF Core 8</p>
                <p><span className="font-semibold text-purple-400">AI Tooling:</span> GPT-4, Anthropic Claude, Vector DB, Prompt Engineering Frameworks</p>
                <p><span className="font-semibold text-purple-400">CMS:</span> Sitecore (7–10), Sitefinity (14), Ektron, Telligent, custom .NET CMS solutions</p>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Contact Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mt-8 text-center backdrop-blur-lg bg-white/10 rounded-xl p-6"
        >
          <h2 className="text-2xl font-semibold mb-4 text-blue-400">Get in Touch</h2>
          <p className="text-gray-300 mb-4">
            Let's discuss your goals—whether it's AI-enabling an existing product, automating content workflows, or building a new .NET solution from scratch.
          </p>
          <div className="flex flex-col sm:flex-row justify-center items-center space-y-2 sm:space-y-0 sm:space-x-6 text-blue-400">
            <a href="https://www.omnigeist.com" className="hover:text-blue-300">www.omnigeist.com</a>
            <a href="mailto:brett.garnier@omnigeist.com" className="hover:text-blue-300">brett.garnier@omnigeist.com</a>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default ConsultingFlyer;
